<template>
  <div class="main-header">
    <button class="sidebar-toggle" type="button" aria-label="展开或收起导航" @click="collapse"><i :class="icon"></i></button>
    <div class="header-heading"><div class="header-breadcrumb">管理控制台 <i class="el-icon-arrow-right"></i> {{ sectionTitle }}</div><h1>{{ pageTitle }}</h1></div>
    <el-dropdown class="account-menu" trigger="click">
      <button type="button" class="account-trigger" aria-label="账户菜单"><span class="account-avatar">{{ (username || '管').slice(0, 1).toUpperCase() }}</span><span class="account-name">{{ username }}<small>管理端账户</small></span><i class="el-icon-arrow-down"></i></button>
      <el-dropdown-menu slot="dropdown"><el-dropdown-item @click.native="toUser">个人中心</el-dropdown-item><el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item></el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
    import { logOut } from '../utils/auth';

    export default{
        name:"MainHeader",

        props:{
            icon:String,
            username: String
        },
        methods:{
            toUser() {
                this.$router.push('/home');
            },
            async logout(){
                // 向服务器发送注销请求
                try {
                    const response = await logOut();
                    if (response.status === 200) {
                        this.$message({
                            type: 'success',
                            message: '注销成功'
                        });
                    }
                } catch (error) {
                    this.$message({
                            type: 'error',
                            message: '登陆过期, 自动注销'
                        });
             
                }
                // 清除localStorage中的认证信息
                localStorage.removeItem('is_logged_in');
                localStorage.removeItem('token');
                localStorage.removeItem('refresh_token');
                localStorage.removeItem('user_name');
                localStorage.removeItem('role');
                
                // 重定向到登录页面
                this.$router.push('/login');
            },
            collapse(){
                this.$emit('doCollapse')
            }
        },
        computed: {
            sectionTitle() {
                if (this.$route.path.startsWith('/orders')) return '订单管理';
                if (this.$route.path.startsWith('/items')) return '仓储管理';
                if (this.$route.path.startsWith('/admin') || this.$route.path.startsWith('/user')) return '用户管理';
                if (this.$route.path === '/home') return '工作台';
                return '运营管理';
            },
            pageTitle() {
                if (this.$route.path.startsWith('/orders/order_status/')) {
                    return this.$route.params.order_status + '订单';
                } 
                if (this.$route.path.startsWith('/items/')) {
                    if (this.$route.params.items_table === 'scanned-items') {
                        return '已入库物品';
                    } else {
                        return '用户申报物品';
                    }
                }  
                if (this.$route.path.startsWith('/admin/admin_users')){
                    return '管理员列表'
                }
                if (this.$route.path.startsWith('/user/users')){
                    return '小程序用户列表'
                }
                if (this.$route.path.startsWith('/orders/order_status_history')){
                    return '订单状态历史'
                }
                if (this.$route.path.startsWith('/excel/export_excel')) {
                    return '导出Excel';
                }
                if (this.$route.path.startsWith('/coupons')) {
                    return '编辑优惠券';
                }
                if (this.$route.path.startsWith('/docs')) {
                    return '编辑公告';
                }
                if (this.$route.path.startsWith('/images')) {
                    return '编辑/上传图片';
                }
                else {
                    return '个人工作台';
                }
            },
        },
    }

</script>

<style scoped>

</style>
